import { FullPageLoader } from '@app/shared/components/full-page-loader';
import { ReactNode, Suspense } from 'react';

export const createSuspendedRoute = (element: ReactNode) => (
  <Suspense fallback={<FullPageLoader />}>{element}</Suspense>
);
